import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import { GoogleMap, LoadScript, Marker, Circle, Polygon } from '@react-google-maps/api'; //https://www.npmjs.com/package/@react-google-maps/api?activeTab=readme
import dayjs from 'dayjs';

const drawingLibraries = []; // keep outside of component so it doesn't cause the map to re-render

export default function OrderMapView(props) {
    const mapRef = useRef(null);
    //const [center, setCenter] = useState(props.center == null ? '' : props.center);
    const GOOGLE_MAPS_API_KEY = 'AIzaSyDqNnSuRDD3nyJ-oVOY4jV7McgqBIDyId0';
    const [markers, setMarkers] = useState([]);
    const [bounds, setBounds] = useState(null);
    const [center, setCenter] = useState({
        lat: 42.958261,
        lng: -85.6739641
    });
    useEffect(() => {
        buildMarkers();
    }, [props]);
   

    function buildMarkers() {
        let orderMarkers = [];
        let allPositions = [];
        //let mapBounds = new window.google.maps.LatLngBounds();
        for (let i = 0; i < props.Orders.length; i++) {
            if (props.Orders[i].Latitude === undefined) {
                console.log('Latitude was null');
            }
            else {
               
                let position = {
                    lat: parseFloat(parseFloat(props.Orders[i].Latitude).toFixed(2)),
                    lng: parseFloat(parseFloat(props.Orders[i].Longitude).toFixed(2))
                }

                allPositions.push([parseFloat(props.Orders[i].Latitude), parseFloat(props.Orders[i].Longitude)]);

                let markerIcon;
                if (props.Orders[i].Status_Reason === 'Scheduled' && props.Orders[i].Owner.toLowerCase() == props.loggedInUser.EmailAddress.toLowerCase()) {
                    markerIcon = getMarkerTypeOpen(props.Orders[i]);
                }
                else {
                    markerIcon = getMarkerTypeAvailable(props.Orders[i]);
                }

                orderMarkers.push(<Marker key={props.Orders[i].OrderGUID}
                    position={position}
                    icon={markerIcon}
                    onClick={() => props.OrderSelected(props.Orders[i])}
                />)
               

                //position = {
                //    lat: parseFloat(props.Orders[i].Latitude),
                //    lng: parseFloat(props.Orders[i].Longitude)
                //}
               

                //allPositions.push([parseFloat(props.Orders[i].Latitude), parseFloat(props.Orders[i].Longitude)]);

                //markerIcon;
                //if (props.Orders[i].Status_Reason === 'Scheduled' && props.Orders[i].Owner.toLowerCase() == props.loggedInUser.EmailAddress.toLowerCase()) {
                //    markerIcon = getMarkerTypeOpen(props.Orders[i]);
                //}
                //else {
                //    markerIcon = getMarkerTypeAvailable(props.Orders[i]);
                //}

                //orderMarkers.push(<Marker key={props.Orders[i].OrderGUID}
                //    position={position}
                //    icon={markerIcon}
                //    onClick={() => props.OrderSelected(props.Orders[i]) }
                ///>
                //)
            }

            let centerPosition = getCenterFromDegrees(allPositions);
            if (centerPosition.length == 2) {
                setCenter({ lat: centerPosition[0], lng: centerPosition[1] });
            }
            setMarkers(orderMarkers);
        }
    }

   

    function getMarkerTypeAvailable(order) {

        let availDate = (dayjs(order.CustomerDateAvailableForPickup.Data));
        
        let tomorrowDate = dayjs().add(1, 'day').endOf('day');

        let locationType = order.LocationType === 'Business' ? 'Business' : 'Residential';
        if (order.ServiceArea === 'Claimed') {
            return 'images/Map/MapMarkerGrey' + locationType + '.png';
        }
        else if (availDate < dayjs().endOf('day')) {
            return 'images/Map/MapMarkerGreen' + locationType + '.png';
        }
        else if (availDate < tomorrowDate) {
            return 'images/Map/MapMarkerYellow' + locationType + '.png';
        }
        else {
            return 'images/Map/MapMarkerRed' + locationType + '.png';
        }
    }

    function getMarkerTypeOpen(order) {
        let availDate = (dayjs(order.ScheduledPickUpDate));
        let tomorrowDate = dayjs().add(1, 'day').endOf('day');

        let startTime = order.EstPickUpWindow.split('_')[0];
        let endTime = order.EstPickUpWindow.split('_')[1];


        if (startTime.indexOf(':00') > -1) {
            startTime = startTime.toLowerCase().replace(':00', '');
        }

        if (endTime.indexOf(':00') > -1) {
            endTime = endTime.toLowerCase().replace(':00', '');
        }
        let locationType = order.LocationType === 'Business' ? 'Business' : 'Residential';
        if (order.IsLate) {
            return 'images/Map/MapMarkerRed' + locationType + '.png';
        }
        else if (availDate < dayjs().endOf('day')) {
            return 'images/Map/MapMarkerGreen' + locationType + '.png';
        }
        else if (availDate < tomorrowDate) {
            return 'images/Map/MapMarkerYellow' + locationType + '.png';
        }
        else {
            return 'images/Map/MapMarkerYellow' + locationType + '.png';
        }
    }

    /**
     * Get a center latitude,longitude from an array of like geopoints
     *
     * @param array data 2 dimensional array of latitudes and longitudes
     * For Example:
     * $data = array
     * (
     *   0 = > array(45.849382, 76.322333),
     *   1 = > array(45.843543, 75.324143),
     *   2 = > array(45.765744, 76.543223),
     *   3 = > array(45.784234, 74.542335)
     * );
    */
    function getCenterFromDegrees(data) {
        if (!(data.length > 0)) {
            return false;
        }

        var num_coords = data.length;

        var X = 0.0;
        var Y = 0.0;
        var Z = 0.0;

        for (let i = 0; i < data.length; i++) {
            var lat = data[i][0] * Math.PI / 180;
            var lon = data[i][1] * Math.PI / 180;

            var a = Math.cos(lat) * Math.cos(lon);
            var b = Math.cos(lat) * Math.sin(lon);
            var c = Math.sin(lat);

            X += a;
            Y += b;
            Z += c;
        }

        X /= num_coords;
        Y /= num_coords;
        Z /= num_coords;

        var lon = Math.atan2(Y, X);
        var hyp = Math.sqrt(X * X + Y * Y);
        var lat = Math.atan2(Z, hyp);

        var newX = (lat * 180 / Math.PI);
        var newY = (lon * 180 / Math.PI);

        return new Array(newX, newY);
    }

    return (
        <LoadScript
            googleMapsApiKey={GOOGLE_MAPS_API_KEY}
            
        >
            <GoogleMap
                
                mapContainerStyle={{ width: props.width, height: '500px' }}
                options={{
                    streetViewControl: false,
                    panControl: false,
                    overviewMapControl: false,
                    mapTypeControl: false,
                    fullscreenControl: false
                }}
                center={center}
                zoom={10}
                onLoad={map => {
                    const bounds = new window.google.maps.LatLngBounds();
                    if (props.Orders.length > 1) {
                        for (let i = 0; i < props.Orders.length; i++) {
                            bounds.extend({
                                lat: parseFloat(props.Orders[i].Latitude),
                                lng: parseFloat(props.Orders[i].Longitude)
                            });
                        }
                        map.fitBounds(bounds);
                    }
                }}
            >
                {markers}
            </GoogleMap>
        </LoadScript>
    )
}